export const environment = {
  production: true,
  api: {
    baseUri: 'https://rest.iqvn.kpmg.com/',
  },
  msal: {
    clientId: 'c8b915ed-3a64-46ab-abd8-93c304186c81',
    authority:
      'https://login.microsoftonline.com/deff24bb-2089-4400-8c8e-f71e680378b2',
    redirectUri: 'https://iqvn.kpmg.com/',
    scopes: [
      "api://c8b915ed-3a64-46ab-abd8-93c304186c81/GO-PROD-ADV-SPN-IQVN-WEU-PD-RITM5159247",
    ]
  },
  fabric: {
    scopes: [
      'https://analysis.windows.net/powerbi/api/Dataset.ReadWrite.All',
      'https://analysis.windows.net/powerbi/api/Report.ReadWrite.All'
    ]
  }
};
